import React from "react";
import {useTranslation} from "react-i18next";
import {minuteToStringForAddShift} from "../../../../utils/helpers";

const ShiftEntryDetailModal = ({
    reportDate,
    fullname,
    tckn,
    cellPhone,
    companyName,
    subCompanyName,
    shiftStartTime,
    shiftEndTime,
    workTimeMinute
}) => {
    const {t} = useTranslation(["shiftScore", "courierStatuses"]);

    return (
        <div>
            <p>
                <b>{t("fields.date", {ns: "common"})}</b> : {reportDate}
            </p>
            <p>
                <b>{t("fields.courier", {ns: "common"})}</b> : {fullname}
            </p>
            <p>
                <b>{t("fields.courierIdNo", {ns: "common"})}</b> : {tckn}
            </p>
            <p>
                <b>{t("fields.courierPhone", {ns: "common"})}</b> : {cellPhone}
            </p>
            <p>
                <b>{t("fields.company", {ns: "common"})}</b> : {companyName}
            </p>
            <p>
                <b>{t("fields.subcompany", {ns: "common"})}</b> : {subCompanyName}
            </p>
            <p>
                <b>{t("shiftScore.shiftStartTime", {ns: "shiftScore"})}</b> : {shiftStartTime}
            </p>
            <p>
                <b>{t("shiftScore.shiftEndTime", {ns: "shiftScore"})}</b> : {shiftEndTime}
            </p>

            <p>
                <b>{t("shiftScore.workTime", {ns: "shiftScore"})}</b> :{" "}
                {minuteToStringForAddShift(workTimeMinute, true)}
            </p>
        </div>
    );
};

export default ShiftEntryDetailModal;
